import React from "react";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import FontAwesomeIcon from "modules/shared/components/icon/font-awesome-icon";
import Colors from "theme/tokens/colors";
import FileItemError from "./file-item-error";

const FileContainer = styled("div")`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

const getFileItemContainerColor = function (isValid) {
  return isValid ? Colors.CONTEXT_SUCCESS_20 : Colors.CONTEXT_DANGER_20;
};

const FileItemContainer = styled("div")`
  background-color: ${(props) => getFileItemContainerColor(props.isValid)};
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  justify-content: ${(props) =>
    props.isStatic ? "flex-start" : "space-between"};
  color: ${(props) =>
    props.isValid ? Colors.CONTEXT_PRIMARY_200 : Colors.CONTEXT_DANGER_200};
  font-size: 14px;
  height: 40px;
`;

const FileItemName = styled("span")`
  width: 100%;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function FileItem({
  file,
  index,
  onDelete = null,
  isValid,
  errors = [],
  isStatic = false,
}) {
  return (
    <FileContainer>
      <FileItemContainer isValid={isValid} isStatic={isStatic}>
        {isStatic && (
          <FontAwesomeIcon
            name="far fa-check-circle"
            color={Colors.CONTEXT_SUCCESS_200}
          />
        )}
        <FileItemName>{file.name}</FileItemName>
        {onDelete && (
          <IconButton
            onClick={() => {
              onDelete(index);
            }}
            color="primary"
            aria-label="deletar arquivo"
            component="span"
          >
            <FontAwesomeIcon
              name="far fa-trash-alt"
              color={
                isValid ? Colors.CONTEXT_PRIMARY_200 : Colors.CONTEXT_DANGER_200
              }
            />
          </IconButton>
        )}
      </FileItemContainer>
      {errors &&
        errors.map((errorCode) => (
          <FileItemError key={`${errorCode}-${index}`} errorCode={errorCode} />
        ))}
    </FileContainer>
  );
}
